import { AppEntry, AppView } from "./ApplicationState/MasterLayoutRouter";

export type AppRouteNames =
    | "community"
    | "quiz"
    | "smicro"
    | "myhome"
    | "PALMS"
    | "pcnaMobileAcademy"
    | "support"
    | "welcome"
    | "termsOfUse"
    | "greeting"
    | "join"
    | "playlist"
    | "wiki"
    | "tube"
    | "podcast"
    | "content"
    | "scorm"
    | "assets"
    | "admin"
    | "slideshow"
    | "best"
    | "activities"
    | "chat"
    | "inbox"
    | "user"
    | "cms"
    | "cmscontent"
    | "faq"
    | "qanda"
    | "search"
    | "thepage"
    | "goToExternal"

    | "demos"
    | "test_stuff"
    | "peTest"
    | "reporting"


    | "app_download"

    // strang things?

    | "wiki_history_view"

    | "open_post"

    | "pag_stats"

    | "dataPrivacy"

    | "myhome_prc"
    | "myhome_udd"
    | "myhome_mc"
    | "myhome_jrr"
    | "myhome_news"
    | "myhome_reports"
    | "learningPath"
    | "session"

    ;

export type ViewRouteNames =
    | "community_feed"
    | "community_feed_trending"
    | "community_add_post"
    | "community_view_post"
    | "community_activities"

    | "quiz_game"
    | "quiz_singleplayer"
    | "quiz_multiplayer"
    | "quiz_join"
    | "quiz_selector"
    | "quiz_details"

    | "demos_demo"
    | "demos_graph"
    | "demos_plassign"
    | "demos_coreBackendTest"

    | "playlist_edit"
    | "playlist_show"
    | "playlist_detail"
    | "playlist_filtered"
    | "playlist_manage"
    | "playlist_assign"
    | "playlist_tube_video_details"
    | "playlist_content_art"
    | "playlist_podcast_audio_details"

    | "playlist_fileentry_video_details"
    | "playlist_fileentry_pdf"
    | "playlist_fileentry_image"
    | "playlist_fileentry_podcast"
    | "playlist_has_work"


    | "tube_cat"
    | "tube_public"
    | "tube_private"
    | "tube_video_details"
    | "tube_mass_upload"

    | "podcast_cat"
    | "podcast_public"
    | "podcast_private"
    | "podcast_audio_details"
    | "podcast_mass_upload"

    | "slideshow_cat"

    | "content_cat"
    | "content_art"

    | "scorm_player"
    | "scorm_legals"

    | "assets_add"

    | "admin"
    | "admin_old"
    | "admin_tube_upload"
    | "admin_podcast_upload"
    | "admin_tube_group"
    | "admin_podcast_group"
    | "admin_user"
    | "admin_user_merge"
    | "admin_newUser"
    | "admin_user_ppn_check"
    | "admin_translateNS"
    | "admin_edit_category_like"
    | "admin_group_mails"
    | "admin_edit_mail"
    | "admin_edit_post"
    | "admin_cat_tree"
    | "admin_categories"
    | "admin_competences"
    | "admin_locations"
    | "admin_ciaNews"
    | "admin_slideshow_group"
    | "admin_slideshow_upload"
    | "admin_send_mail"
    | "admin_certificate_group"
    | "admin_content_group"
    | "admin_content_edit"
    | "admin_group_members"
    | "admin_group_management"
    | "admin_newGroup"

    | "admin_quiz_group"
    | "admin_quiz_edit"
    | "admin_quiz_and_question_edit"

    | "slideshow_slides_show"
    | "slideshow_access_tokens"
    | "slideshow_slide"
    | "slideshow_slide_edit"
    | "slideshow_view"

    | "best_add"
    | "best_detail"

    | "chat_add"
    | "chat_open"

    | "cms_project"
    | "cms_templates"
    | "cms_template"
    | "cms_roles"
    | "cms_create_edit_role"
    | "cms_dir"
    | "cms_translation_batches"
    | "cms_file"
    | "cms_archive"
    | "cms_archive_file"
    | "cms_select_workflow"
    | "cms_locations"
    | "cms_categories"
    | "cms_create_edit_workflow"
    | "cms_content"

    | "wiki_category"
    | "wiki_article"
    | "wiki_create_article"
    | "wiki_edit_article"
    | "wiki_add_news"
    | "wiki_news"
    | "wiki_recently"
    | "wiki_faq"
    | "wiki_translation_send"
    | "wiki_translation_import"
    | "wiki_copyWikiGroup"
    | "wiki_history"
    | "wiki_admin_review_view"
    | "wiki_reviewer_overview"


    | "q&a_category"
    | "q&a_element"
    | "q&a_mockup"
    | "q&a_edit_question"
    | "q&a_admin"
    | "q&a_admin_stats"
    | "q&a_admin_incoming_questions"
    | "q&a_submitted_questions"
    | "q&a_admin_history"
    | "q&a_search"
    | "q&a_mail_config"

    | "testUCTS"

    | "myhome"
    | "myhome_prc"
    | "myhome_udd"
    | "myhome_mc"
    | "myhome_jrr"
    | "myhome_news"
    | "myhome_reports"

    | "inbox"
    | "user_bookmarks"
    | "user_details"

    | "dataPrivacy"
    | "learningPath"

    | "session_new"
    | "session_edit"
    | "session_add"
    | "session_template_new"
    | "session_template_edit"
    | "session_admin_overview"
    | "sessionTypes"
    | "sessionResourceTypes"
    | "sessionResources"
    | "sessionInformations"
    | "session_enroll_to"
    | "session_admin_enrollments"
    | "session_roles"
    | "session_role"
    ;

export type ThisAppView = Omit<AppView, "routeName" | "name"> & { routeName: ViewRouteNames };
export type ThisAppEntry = Omit<AppEntry, "routeName" | "views"> & { routeName: AppRouteNames, views?: ThisAppView[] };

export const manipulateRoutePrefix = <T extends string = ViewRouteNames>(routeName: T, oldPrefix: string, newPrefix?: string): T => {
    const s: string = routeName;
    if (newPrefix) {
        const toRet = s.replace(new RegExp(`^${oldPrefix}`), newPrefix) as T;
        return toRet;
    }
    return routeName;
}